import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import GlossaryTermDefinition from './GlossaryTermDefinition';

interface SectionTextGlossaryTermProps {
  originalText: string;
  termId: number;
}

const SectionTextGlossaryTerm = ({ originalText, termId }: SectionTextGlossaryTermProps) => {
  const termRef = useRef<HTMLDivElement>(null);
  const [showDefinition, setShowDefinition] = useState(true);
  const [glossaryTerm, setGlossaryTerm] = useState(null);

  useEffect(() => {
    axios.get(Routes.plato_api_glossary_term_path(termId))
      .then(res => setGlossaryTerm(res.data.glossary_term));
  }, []);

  if (!glossaryTerm) return null;

  return (
    <>
      <strong
        ref={termRef}
        className="glossary-text tw-underline tw-cursor-pointer"
        role="button"
        onClick={() => setShowDefinition(prev => !prev)}
      >
        {originalText}
      </strong>
      <GlossaryTermDefinition
        buttonRef={termRef}
        glossaryTerm={glossaryTerm}
        setShowDefinition={setShowDefinition}
        showDefinition={showDefinition}
      />
    </>
  );
};

export default SectionTextGlossaryTerm;
